// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__xb6r0"};